import { Link } from 'react-router-dom';
import { ArrowRight, Plus } from 'lucide-react';
import './HomeSections.css';

// Answers follow the Terms (sections 5, 6, 8) and Refund Policy pages.
const QUESTIONS = [
  {
    q: 'How do I get the project after paying?',
    a: (
      <>
        Orders are typically processed within 12 hours of payment. Once
        processed, your downloads and repository access appear on the order
        page in <Link to="/profile">your account</Link>. For GitHub access, accept
        the invitation GitHub sends you.
      </>
    ),
  },
  {
    q: 'How do I pay?',
    a: (
      <>
        Checkout uses UPI. Scan the QR code shown at checkout with any UPI app
        and complete the payment. We verify it before unlocking your project.
        All prices are in Indian Rupees.
      </>
    ),
  },
  {
    q: 'Do I get the full source code?',
    a: (
      <>
        Yes. Every project is a complete source code bundle. Each project page
        lists exactly what's included, such as documentation, database design,
        setup videos or a project report.
      </>
    ),
  },
  {
    q: 'Can you customize a project or build one from scratch?',
    a: (
      <>
        Yes. Describe what you need on the{' '}
        <Link to="/request-project">custom build page</Link> and we'll get back
        to you.
      </>
    ),
  },
  {
    q: 'Can I get a refund?',
    a: (
      <>
        No. Projects are digital and can be downloaded as soon as they're
        delivered, so all sales are final. Check the project details, or ask
        us, before you buy. Read the full{' '}
        <Link to="/refund">refund policy</Link>.
      </>
    ),
  },
];

const HomeFaq = () => (
  <section className="hs" aria-labelledby="hs-faq-title">
    <div className="hs__inner hs-faq">
      <div className="hs-faq__intro">
        <h2 id="hs-faq-title" className="hs__title">
          Questions before you buy
        </h2>
        <p className="hs__sub">
          Can't find what you're looking for? We're happy to help before you
          pay.
        </p>
        <Link className="hs__link" to="/contact">
          Contact us
          <ArrowRight aria-hidden="true" />
        </Link>
      </div>

      <div className="hs-faq__list">
        {QUESTIONS.map(({ q, a }) => (
          <details key={q} className="hs-faq__item">
            <summary className="hs-faq__q">
              {q}
              <Plus aria-hidden="true" />
            </summary>
            <p className="hs-faq__a">{a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default HomeFaq;
